import React, { useState } from 'react';

// React Router Dom
import { Link } from 'react-router-dom';

// PropTypes
import PropTypes from 'prop-types';

// Local Components
import GlassmorphismCard from './GlassmorphismCard';
import SpanTag from '../FormFields/SpanTag';
import { H5, Body3 } from '../../themes/typography';

// Icon
import { StarIcon } from '../../icons/FontAwesomeIcon';

// CSS
import '../../styles/components/VenueCard.css';

const venueImage =
    'https://img.freepik.com/free-photo/architecture-ancient-monument-world-heritage-day-celebration_23-2151297159.jpg?t=st=1725709658~exp=1725713258~hmac=431acf8cc286dd08111a0376a73a5f28a1364f41717c5bf1a06acdb09a5fb98c&w=1060';

export default function VenueCard({
    thumbnail = venueImage,
    name = 'Girnar Multi Cuisine Restaurant',
    ratings = 4.5,
    venueCategory = <SpanTag eventFormatTag="Restaurant" />,
    location = 'Adajan Gam, Surat',
    opensAt = 'Opens at 11:30am',
    closesAt = 'Closes at 11:00pm',
    price = '₹3200 for two'
}) {
    // State to manage the visibility of the glassmorphism card on hover effect
    const [isShown, setIsShown] = useState(false);

    return (
        // Main Venue Card Container
        <Link
            className="main-venue-card-container"
            onMouseEnter={() => setIsShown(true)}
            onMouseLeave={() => setIsShown(false)}
            to={`/venue-detail-page/#`}
        >
            {/* Venue Image */}
            <section className="venue-image-section">
                <img src={thumbnail} alt="Venue Thumbnail" />
            </section>

            {/* Venue Details Section */}
            <section className="venue-details-section">
                {/* Venue Title and Category Container */}
                <div className="venue-title-and-category-container">
                    {/* Venue Name */}
                    <div className="venue-title-container">
                        <H5 color="#F8A21E" fontWeight={600}>
                            {name}
                        </H5>
                    </div>

                    <div className="venue-category-and-ratings-container">
                        {/* Venue Ratings */}
                        <div
                            className="ratings-container"
                            style={{
                                backgroundColor: ratings <= 2.5 ? '#ef4f5f' : '#267e3e'
                            }}
                        >
                            <Body3 fontWeight={600}>{ratings}</Body3>
                            <StarIcon
                                style={{
                                    color: '#F5F5F5',
                                    marginBottom: '2px',
                                    fontSize: '0.875rem'
                                }}
                            />
                        </div>

                        {/* Venue Category */}
                        <div className="venue-category">{venueCategory}</div>
                    </div>
                </div>

                {/* Venue Address, Timing and Pricing Container */}
                <div className="venue-location-timing-pricing-container">
                    <div className="venue-details-content">
                        {/* Venue Location */}
                        <div className="venue-location">
                            <Body3
                                style={{
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                {location}
                            </Body3>
                        </div>

                        {/* Venue Timing */}
                        <div className="venue-timing">
                            <Body3
                                style={{
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                {opensAt}
                            </Body3>
                        </div>

                        {/* Venue Pricing */}
                        <div className="venue-pricing">
                            <Body3
                                style={{
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                {price}
                            </Body3>
                        </div>
                    </div>
                </div>
            </section>

            {/* Glassmorephism Card */}
            <GlassmorphismCard isShown={isShown} />
        </Link>
    );
}

// PropTypes
VenueCard.propTypes = {
    thumbnail: PropTypes.string,
    name: PropTypes.string,
    ratings: PropTypes.number,
    venueCategory: PropTypes.element,
    location: PropTypes.string,
    opensAt: PropTypes.string,
    closesAt: PropTypes.string,
    price: PropTypes.string || PropTypes.number
};

// Note:
// => Venue Timing will dynamically change before or after the venue opens or close.
// Countdown timer will start before 1 hour to the venue opens and close before 1 hour to the venue closes. Countdown will runs in minutes.
// 1. By default the specified time of venue will be displayed in a card.
// 2. As soon as the venue time is about to open (1 hour before) the venue time will be changed to Like "Opens in 50 minutes, Opens in 30 minutes etc".
// 3. As Venue Opens the status will be changed to "Open Now".
// 4. As soon as the venue time is about to close (1 hour before) the venue time will be changed to Like "Closes in 50 minutes, Closes in 30 minutes etc".
// 5. As Venue Closes the status will be changed to "Opens at 11.30 AM".
